import { Endpoints } from '@/core/models/endpoints.interface';

export const USER_INFO_ENDPOINTS: Pick<Endpoints, 'GET'> = {
   GET: () => '/user-info?include=tenant,modules,teams,language',
};
